export default {
  send: 'verification/SEND',
  sendSuccess: 'verification/SEND_SUCCESS',
  sendFailure: 'verification/SEND_FAILURE',

  validate: 'verification/VALIDATE',
  validateSuccess: 'verification/VALIDATE_SUCCESS',
  validateFailure: 'verification/VALIDATE_FAILURE',
};
